import { Appointment } from "@/services/appointments/appointments";

export const getAppointmentTitle = (appointment: Appointment) => {
  if (appointment.servicePackage) {
    const maintenanceSchedule =
      appointment.servicePackage.maintenanceSchedule?.find(
        (maintenance) => maintenance.id === appointment.maintenanceScheduleId
      );

    return `${appointment.servicePackage.name} - ${maintenanceSchedule?.name}`;
  }

  if (appointment.type === "repair") {
    return "Reparatie";
  }

  return "Onderhoud";
};
